export default __webpack_public_path__ + "static/media/kingsfund.251ae8ec.png";